export const wintergreenTokens = {
    tokens: {
        blendBackground: '#1df5e9',
        blendIntersection: '#00a600',
        blendForeground: '#00d924',
        gradientColorZero: '#20d261',
        gradientColorOne: '#1df5e9',
        gradientColorTwo: '#00ff91',
        gradientColorThree: '#1df5e9',
        gradientColorZeroTransparent: '#4436ff00',
        gradientColorOneTransparent: '#5566ff00',
        gradientColorTwoTransparent: '#d679ff00',
        gradientColorThreeTransparent: '#04ffff00',
        shadeOneColor: '#16cbe1',
        shadeTwoColor: '#20b5e3',
        shadeThreeColor: '#1086db',
        shadeFourColor: '#1959e6',
        shadeFiveColor: '#9966ff',
        shadeSixColor: '#002c59'
    },
    themeTokens: {
        dark: {
            blendBackground: '#00d924',
            blendIntersection: '#cbffef',
            blendForeground: '#1df5e9'
        }
    },
    accents: {
        green: {
            tokens: {
                accentColor: '#15be53'
            },
            themeTokens: {
                dark: {
                    accentColor: '#14d433'
                }
            }
        },
        teal: {
            tokens: {
                accentColor: '#00c4c4'
            },
            themeTokens: {
                dark: {
                    accentColor: '#0de4e4'
                }
            }
        }
    }
};

//# sourceMappingURL=Wintergreen.js.map